import { FC, useState } from 'react';

import { Col, Row } from 'antd';
import { handleCutString } from 'tools/cutstring';
import { Dropdown, Icon } from 'ui';

import { ExtraField } from 'services/events/evetns.api.type';

import s from '../ExtraFields.module.scss';

interface ExtraFieldsItemProps {
  handleDeleteFieldItem: (id: string) => void;
  setExtraField: (extraField: ExtraField) => void;
  extraField: ExtraField;
  groupId?: string;
  groupName?: string;
  id: string;
}

const DROPDOWN_ITEMS = [
  { key: 'edit', label: <div className={s.dropdownItem}>Edit</div> },
  { key: 'delete', label: <div className={s.dropdownItem}>Delete</div> },
];

const fieldTypeLabels: Record<string, string> = {
  string: 'String',
  number: 'Number',
  dropdown: 'Dropdown',
  textArea: 'TextArea',
  checkBox: 'CheckBox',
  fileUpload: 'File Upload',
};

const ExtraFieldsItem: FC<ExtraFieldsItemProps> = ({
  handleDeleteFieldItem,
  id,
  groupId,
  groupName,
  extraField,
  setExtraField,
}) => {
  const [openedDropdown, setOpenedDropdown] = useState(false);

  const handleClickDropdownItems = (event: { key: string }, id: string) => {
    if (event.key === 'delete') {
      setOpenedDropdown(false);
      handleDeleteFieldItem(id);
    }

    if (event.key === 'edit') {
      setOpenedDropdown(false);
      setExtraField({
        ...extraField,
        groupId: groupId,
      });
    }
  };
  return (
    <Row
      gutter={[0, 8]}
      style={{
        minWidth: 600,
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 16,
        paddingBottom: 16,
      }}>
      <Col span={2}>{fieldTypeLabels[extraField?.fieldType]}</Col>
      <Col span={2}>{handleCutString(extraField?.caption ?? '', 10, true)}</Col>
      <Col span={2}>{extraField?.name}</Col>
      <Col span={4}>{handleCutString(extraField?.optionsAvailable ?? '', 20, true)}</Col>
      <Col span={2}>{extraField?.sortOrder}</Col>
      <Col span={2}>{groupName}</Col>
      <Col span={4}>{handleCutString(extraField?.captionToShowOnTicket ?? '', 10, true)}</Col>
      <Col span={2}>{handleCutString(extraField?.defaultValue ?? '', 10, true)}</Col>
      <Col span={2}>{handleCutString(extraField?.helpInformation ?? '', 10, true)}</Col>
      <Col span={2}>
        <Dropdown
          items={DROPDOWN_ITEMS}
          placement="bottomRight"
          handleItemClick={(event) => handleClickDropdownItems(event, id as string)}
          open={openedDropdown}
          onOpenChange={setOpenedDropdown}>
          <div className={s.dropdownButton}>
            <Icon name="verticalDots" color="#7d7da2" />
          </div>
        </Dropdown>
      </Col>
    </Row>
  );
};

export default ExtraFieldsItem;
